import React, { useState } from "react";
import { useAuth } from "../lib/auth";
import { Navigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Logo } from "../components/Logo";

export default function Login() {
  const { user, login, error } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user !== false) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await login(email, password);
    setLoading(false);
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2" data-testid="login-page">
      {/* Left */}
      <div className="flex flex-col justify-between p-10 bg-white relative">
        <div className="flex items-center gap-3">
          <Logo height={34} />
          <span className="label-caps text-slate-400 border-l border-slate-300 pl-3">Order Management</span>
        </div>

        <div className="max-w-md">
          <div className="label-caps mb-3">Sign in</div>
          <h1 className="font-display text-5xl tracking-tighter font-light text-slate-900 leading-[1.05] mb-2">
            Component<br/>distribution,<br/>tracked end-to-end.
          </h1>
          <p className="text-sm text-slate-500 mb-8">icmarkt · Offers → Orders → Purchases. One clean pipeline.</p>

          <form onSubmit={submit} className="space-y-5">
            <div>
              <Label className="label-caps" htmlFor="email">Email</Label>
              <Input
                id="email"
                data-testid="login-email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                className="mt-1.5 rounded-none border-slate-300 focus-visible:ring-blue-600"
                required
              />
            </div>
            <div>
              <Label className="label-caps" htmlFor="password">Password</Label>
              <Input
                id="password"
                data-testid="login-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type="password"
                className="mt-1.5 rounded-none border-slate-300 focus-visible:ring-blue-600"
                required
              />
            </div>
            {error && <div className="text-sm text-red-600" data-testid="login-error">{error}</div>}
            <Button
              type="submit"
              disabled={loading}
              data-testid="login-submit"
              className="w-full rounded-none bg-blue-600 hover:bg-blue-700 text-white font-medium transition-colors duration-200"
            >
              {loading ? "SIGNING IN…" : "SIGN IN"}
            </Button>
            <div className="text-xs text-slate-500">
              Access is issued by an administrator. Contact your admin if you need an account.
            </div>
          </form>
        </div>

        <div className="label-caps">v1.0 · secured session</div>
      </div>

      {/* Right hero image */}
      <div
        className="hidden lg:block relative bg-slate-900"
        style={{
          backgroundImage:
            "url(https://images.unsplash.com/photo-1592659762303-90081d34b277?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxlbGVjdHJvbmljJTIwY2lyY3VpdCUyMGJvYXJkJTIwbWFjcm98ZW58MHx8fHwxNzg0NDA2MjIwfDA&ixlib=rb-4.1.0&q=85)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-slate-950/60" />
        <div className="absolute bottom-10 left-10 right-10 text-white">
          <div className="label-caps text-slate-300 mb-2">System · 001</div>
          <div className="font-display text-3xl tracking-tight">Every part number. Every supplier. Every purchase.</div>
        </div>
      </div>
    </div>
  );
}
